import React, { memo } from 'react'

import ReactTooltip from 'react-tooltip'

const Tooltip = ({ id, place }) => (
  <ReactTooltip id={id} place={place} delayShow={600} className="tooltip-inner" />
)

export default memo(Tooltip)
